import {isArrayNullUndefinedOrEmpty} from "../../../../services/Validator";
import FlashResultsQuestionItem from "../../../items/courses/flash/FlashResultsQuestionItem";

export function FlashResultsQuestionsList({levelA, questions}) {
    // Used in FlashResultsScreen to display list of current
    // flash questions

    // BUILD
    if (isArrayNullUndefinedOrEmpty(questions))
        return null;
    return (
        <div className={"w-full grow flex flex-col justify-start py-[10px] space-y-[6px]"}>
            {questions?.map((question, index) => (
                <FlashResultsQuestionItem key={index}
                                          index={index}
                                          total={questions.length}
                                          question={question}
                                          levelA={levelA} />
            ))}
        </div>
    );
}